var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCricleCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48636",
    "data-name": "Group 48636",
    transform: "translate(-498 -1250)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93216",
    "data-name": "Path 93216",
    d: "M24,0A24,24,0,1,1,0,24,24,24,0,0,1,24,0Z",
    transform: "translate(498 1298) rotate(-90)",
    fill: "#4ac18e",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_341",
    "data-name": "Ellipse 341",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(504 1292) rotate(-90)",
    fill: "#4ac18e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93215",
    "data-name": "Path 93215",
    d: "M4380.529-2727.461l3.938,4.688,10.875-9",
    transform: "translate(-3865.936 4001.274)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCricleCheck);
export default __webpack_public_path__ + "static/media/cricle-check.5e53f10de381eb9e41fdde3f301bb027.svg";
export { ForwardRef as ReactComponent };